<template>
	<div id="footer">

		<div class="footer-item col-md-4 col-xs-12">
			<h2>Our Credo</h2>
			<p>If quality comes at a price, why does Apollo come handy? 
			<br/><br/>Because Apollo understands Because Apollo believes that suiting your senses is as important as suiting your mind.
			<br/><br/>Because as Apollo meets your needs, so is its purpose.
			</p>
		</div>

		<div class="footer-item col-md-4 col-xs-12">
			<h2>Contact Info</h2>
			<p>Mutual Success Lighting Fixtures Inc.
			<br/>Suite 3003-A East Tower, PSE Center, Exchange Road, 
			<br/>Ortigas Center, Pasig City
			<br/><br/>
			Landline # (632) 687-7111
			<br/>Fax # (632) 687-7111 loc 5
			</p>
		</div>

		<div class="footer-item col-md-4 col-xs-12" v-if="!disabled">
			<h2>Subscribe to our Newsletter</h2>
			<div id="newsletter">
			<input v-if="show" type="text" placeholder="type your email here"/>
			<button type="button">Subscribe</button>
			</div>
		</div>

	</div>
</template>

<script>
	export default{
		props: ['issessionset'],
		data(){
			return{
				show: true,
				disabled: true
			}
		},
		created(){
			if(this.issessionset === true){
				this.show = false;
			}
		},
		mounted(){
			relativeTo('nav', this.$el);
		},
		watch:{
			issessionset: function(newval){
				if(newval === true){
					this.show = false;
				}else{
					this.show = true;
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Footer.vue?2858be0c